import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropertyHeader from "../../Projects/AssociatePanel/componets/HeaderProperty/PropertyHeader";
import EcomHeader from "../../Projects/OrgEcommerce/Componets/HeaderEcom/EcomHeader";
import useApiRequest from "../../Hooks/apiReq";
import { useDispatch } from "react-redux";
import { assoProfileDetails } from "../../Redux/Slices/associateProfileDetailsSlice";
import MakarSankranti2026 from "../../CommonComponets/NewYearWish";
import BottomDetails from "../../Projects/OrgEcommerce/Componets/BottomDetails/BottomDetails";
const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("loggedInUser");
  const dispatch = useDispatch();
  const apptype = sessionStorage.getItem("Apptype");
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const getAssociateProfile = () => {
    sendApiRequest("POST", "/Profile/GetProfileDetails", "", {
      onSuccess: (res) => {
        // console.log("Profile Data", res);
        dispatch(assoProfileDetails.setProfileDetails(res?.data));
      },
    });
  };

  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
    } else getAssociateProfile();
  }, [token, navigate]);
  const [isDetailsOpen, setIsDetailsOpen] = useState(true);

  return (
    <>
      {apptype === "Business" ? <PropertyHeader /> : <EcomHeader />}
      {/* <Breadcrumb /> */}
      {/* <MakarSankranti2026 /> */}
      {/* <BottomDetails
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        title="Member Performance"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <p>
            <strong>Associate Name:</strong> Sneha Gupta
          </p>
          <p>
            <strong>Rank:</strong> Gold Director
          </p>
          <div style={{ borderTop: "1px solid #eee", paddingTop: "12px" }}>
            <p>Self Business: ₹2,500</p>
            <p>Team Business: ₹6,00,000</p>
          </div>
          <button
            style={{
              padding: "12px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "8px",
            }}
            onClick={() => alert("Viewing deeper downline...")}
          >
            Explore Team
          </button>
        </div>
      </BottomDetails> */}
      {children}
    </>
  );
};
export default PrivateRoute;
